import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Breadcrumb } from '../../@types/Breadcrumb';
import { BreadCrumbService } from '../../services/breadcrumb/bread-crumb.service';

@Component({
  selector: 'app-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.scss']
})
export class BreadCrumbComponent {
  breadcrumbs$: Observable<Breadcrumb[]>;

  constructor(private readonly breadcrumbService: BreadCrumbService) {
    this.breadcrumbs$ = this.breadcrumbService.breadcrumbs$;

  }
}
